import { makeApiCall } from "../apirequest";

export default {
  state: {
    users: [],
    organizationId: localStorage.getItem("organizationId") || 0,
  },
  getters: {
    getUsers: (state) => state.users,
    getOrganizationId: (state) => state.organizationId,
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    getOrganizationId({ commit }, id) {
      commit("setOrganizationId", id);
    },
  },
  actions: {
    async getUsers({ commit }, payload) {
      let url = "Admin/GetUsersForAdmin";
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("SET_USERS", response.data.data);
      }
      return response;
    },
    setOrganizationId: (state, payload) => {
      state.organizationId = payload;
      localStorage.setItem("organizationId", payload);
    },
  },
};
